<template>
  <!-- 公用组件-选择、新增信息输入框  -->
  <div>
        <!-- <vxe-toolbar id="xTable_5" size="mini" :resizable="{storage: true}"></vxe-toolbar> -->
		<vxe-table
        id="xTable"
          ref="xTable"
          border
          resizable
          size="mini"
          height="400"
          :data="tableData1"
          highlight-hover-row
          highlight-current-row
          :keyboard-config="{isArrow: true}">
            <vxe-table-column type="index" align="center" width="45" fixed="left">
				<template v-slot:header="{ column }">
					<i class="el-icon-s-tools" style="color:#2594ff;font-size:18px" @click="tableConfigShow=true"></i>
				</template>
				<template v-slot="{ column , rowIndex }">{{rowIndex+1 }}</template>
			</vxe-table-column>
            <vxe-table-column width="100" align="center" title="操作" fixed="left">
                <template v-slot="{row,rowIndex}">
                    <el-button type="text" size="mini" @click.native.prevent="addRow(rowIndex)">新增</el-button>
                    <el-button type="text" size="mini" @click.native.prevent="deleteRow(rowIndex)">移出</el-button>
                </template>
            </vxe-table-column>
			<template v-for="(item,index) in ConfigData">
                <vxe-table-column v-if="item.Key=='FullName'||item.Key=='BaseCode'&& item.Show == true" :field="item.Key" :title="item.Rename" align="center" width="180" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <el-input size="mini" type="text" :ref="rowIndex+'A'+columnIndex" @dblclick.native="dbClick(rowIndex)" @keydown.enter.native="enterKey(rowIndex,item,columnIndex)"></el-input>
                    </template>
                </vxe-table-column>
          		<vxe-table-column v-else-if="item.Key!='FullName'&&item.Key!='BaseCode'&& item.Show == true" :field="item.Key" :title="item.Rename" align="center" width="180" :key="index">
                    <template v-slot="{row,rowIndex,columnIndex}">
                        <el-input size="mini" type="text" :ref="rowIndex+'A'+columnIndex" v-model="row[item.Key]" v-if="row.Name!=''&& row.PtypeId!=''&&(item.Key=='Total'||item.Key=='Discount'||item.Key=='DiscountPrice'||item.Key=='DiscountTotal'||item.Key=='Tax')" @keydown.enter.native="enterKey(rowIndex,item,columnIndex)"></el-input>
                        <el-input size="mini" type="text" :ref="rowIndex+'A'+columnIndex" v-model="row[item.Key]" v-else-if="row.Name!=''&& row.PtypeId!=''&&item.Key=='Qty'" @keydown.enter.native="enterKey(rowIndex,item,columnIndex)"></el-input>
                        <el-input size="mini" type="text" :ref="rowIndex+'A'+columnIndex" v-model="row[item.Key]" v-else-if="row.Name!=''&& row.PtypeId!=''&&(item.Key=='Memo'||item.Key=='BString1'||item.Key=='BString2'||item.Key=='BString3'||item.Key=='BString4'||item.Key=='BString5')" @keydown.enter.native="enterKey(rowIndex,item,columnIndex)"></el-input>
                        <div v-else-if="row.Name!==''&& row.PtypeId!==''&& item.Key=='PStutas'" class="only_show_div">
                            <el-select v-model="row[item.Key]" placeholder="请选择" size="mini" @change="selcetChange($event,row,rowIndex)">
                                <el-option label="非赠品" :value="0"></el-option>
                                <el-option label="赠品" :value="1"></el-option>
                            </el-select>
                        </div>
                    </template>
                </vxe-table-column>
			</template>
        </vxe-table>
		<!-- table表格配置弹出框 -->
    	<TableConfigDialog :show.sync="tableConfigShow" :tableData="ConfigData" v-bind="$attrs" v-on="$listeners" @restoreDefault="restoreDefault"/>
  </div>

</template>

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";
export default {
    data() {
        return {
			// 状态值
			tableConfigShow:false,//是否显示表头配置弹出框
			ConfigData: this.tableConfigData, //表头配置项数据
			tableData1:this.tableData,//表格数据
        };
    },
    props:{
		tableData: Array,//表格数据
    	tableConfigData: Array, //表头配置项数据
    },
    watch:{
        // tableData: {
        //     handler(newVal, oldVal) {
        //         // this.initial();
        //     }
        // },
        tableConfigData: {
            handler(newValue, oldValue) {
                // this.ObtainHeader = newValue;
                // this.initial();
                this.ConfigData = newValue;
            },
            deep: true,
            // immediate:true
        }
    },
    methods:{
        // nextFocus(row, index, e){
        //     console.log(e)
        //     if (i>=Object.keys(this.$refs).length) {
        //         i = Object.keys(this.$refs).length -1;
        //     }
        //     // this.$emit("keyUse",e)
		// 	e.target.blur() // 或者this.$refs[row.id].blur()
		// 	// this.$refs[Object.keys(this.$refs)[index + 1]].focus();
		// 	// TODO  需要对最后一个input做判断
		// 	// console.log(Object.keys(this.$refs),index);
        //     this.$refs[Object.keys(this.$refs)[i]].focus();
        //     i++
        // },
        // 保存表格表头配置
        restoreDefault(){

        },
        // 新增一行
        addRow(rowIndex){
            let rowData = {...dataConfig.emptyData};
            this.tableData1.splice( rowIndex+1 , 0 , rowData);
            this.$refs.xTable.refreshData();
        },
        // 删除一行
        deleteRow(rowIndex){
            if(this.tableData1.length > 1){
                this.tableData1.splice( rowIndex , 1);
            }else{
                this.$message({
                    message: '不能将表格数据删除为空',
                    type: 'warning'
                });
            }
            // this.$refs.xTable.remove(this.tableData1[rowIndex]);
            this.$refs.xTable.refreshData();
        },
        // 双击某一行
        dbClick(index){
            this.tableData1[index].Name = '测试名称';
            this.tableData1[index].PtypeId = 66;
            this.$refs.xTable.refreshColumn();
            this.$refs.xTable.recalculate();
            this.$refs.xTable.refreshData();

            // this.$refs.FullName4[0].focus();
            // console.log(this.$refs)
        },
        // 按回车键
        enterKey(rowIndex,item,columnIndex){
            let refName = rowIndex+'A'+columnIndex;
            let refIndex = Object.keys(this.$refs).indexOf(refName);
            // console.log(Object.keys(this.$refs))
            if (refIndex>=0) {
                // 向下一个单元格聚焦
                this.$refs[Object.keys(this.$refs)[refIndex+1]][0].focus();
                if(item.LastOne){
                    this.$refs.xTable.setCurrentRow(this.tableData1[rowIndex+1]);
                }
            }else{

            }
            // console.log(this.$refs[Object.keys(this.$refs)[refIndex+1]]);
        },
        selcetChange(val,data,index){
            // console.log('选择框数据',val,data,index);
            // data.Qty = 0;//数量
            data.ShowPrice = 0;//单价
            data.Total = 0;//金额
            data.Tax = 0;//税率
            data.TaxPrice = 0;//含税单价
            data.WithTaxTotal = 0;//含税金额
            data.TaxTotal = 0;//税额
            data.Discount = 1;//折扣
            data.DiscountPrice = 0;//折扣单价
            data.DiscountTotal = 0;//折扣金额
            data.SaleTotal = 0;//零售金额
        },
        sortData(a,b){
            let aIndex = a.indexOf('A');
            let aSuIndex = a.substring(0,aIndex);
            let bIndex = b.indexOf('A');
            let bSuIndex = b.substring(0,bIndex);
            if (Number) {
                
            }
        }
    },
    mounted(){
        // console.log('======>',this.tableConfigData)
    },
    updated(){
        // console.log(this.ConfigData)
        // this.$refs.xTable.refreshData();
        // this.$refs.xTable.recalculate();
    }

};

</script>

<style lang="less">
.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {/*滚动条整体样式*/
    width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #ccc;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #EDEDED;
}

.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar {/*滚动条整体样式*/
    width: 1px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #ccc;
}
.el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track {/*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #EDEDED;
}
.vxe-toolbar.size--mini, .vxe-toolbar.size--small{
    padding: 0; 
}
</style>


// WEBPACK FOOTER //
// src/components/Table/MaOrderTable/MaOrderTable.vue